import { useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { saveCompanyWithSirenGuard } from '../lib/companies';

export const SirenInlineInput = ({ api, company, canForce, onSaved }) => {
    const [value, setValue] = useState('');
    const [saving, setSaving] = useState(false);

    const save = async () => {
        const siret = value.replace(/[\s.-]/g, '');
        if (!/^(\d{9}|\d{14})$/.test(siret)) {
            toast.error('SIREN (9 chiffres) ou SIRET (14 chiffres) attendu');
            return;
        }
        setSaving(true);
        try {
            await saveCompanyWithSirenGuard(
                (force) => api.patch(`/companies/${company.id}${force ? '?force=true' : ''}`, { siret }),
                { api, canForce }
            );
            toast.success(`SIREN enregistré pour ${company.legal_name}`);
            onSaved();
        } catch (error) {
            if (!error.handled) toast.error(error.response?.data?.detail || "Erreur lors de l'enregistrement");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
            <Input
                value={value}
                onChange={(e) => setValue(e.target.value.replace(/[^\d\s.-]/g, ''))}
                onKeyDown={(e) => e.key === 'Enter' && save()}
                placeholder="SIREN ou SIRET"
                className="h-8 w-40 rounded-lg"
                data-testid={`inline-siren-input-${company.id}`}
            />
            <Button size="icon" variant="ghost" className="h-8 w-8" disabled={saving} onClick={save} data-testid={`inline-siren-save-${company.id}`}>
                {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            </Button>
        </div>
    );
};
